import React from "react"

const Started = () => {
  return (
    <div className="started">
      <div className="container">
        <div className="started__content">
          <img className="started__image--arrow" src="./arrow-down.svg" />
          <img className="started__image--rain" src="./rain.svg" />

          <div className="started__text">
            <h1 className="started__text--heading">Getting Started</h1>
            <p className="started__text--description">
              Start your day off with workouts, brain games, breakfast and more. Click on the categories below to join these exciting morning experiences. 
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Started
